import React, { useContext, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import "../../assets/css/modal.css";
import "./LoginModal.module.css";
import axios from "axios";
import { baseUrl, portal, dataContext } from "../../App";
import activityLogSubmission from "../../helper/activitylog";
import { useNavigate, useSearchParams } from "react-router-dom";
import analyticEvent from "../../helper/gaEvent";
import styles from "./LoginModal.module.css";
import xImg from "./assets/x.png";
import loginIcon from "./assets/login_icon.png";
import { pushCleverTapEvent } from "../../helper/clevertapFunction";
import clevertap from "clevertap-web-sdk";

const LoginModal = ({
  showLoginModal,
  setShowLoginModal,
  activeBottom,
  setActiveBottom,
  setShowTCModalTournament,
}) => {
  const { token, setToken, playerData, setPlayerData } =
    useContext(dataContext);
  const [mobileNumber, setMobileNumber] = useState("");
  const [showErrorOutline, setShowErrorOutline] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isMobileNumberOkay, setIsMobileNumberOkay] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  let navigate = useNavigate();
  useEffect(() => {
    analyticEvent("login", "login-view");
  }, []);
  if (activeBottom === "campaign") {
    localStorage.setItem("AuthToken", "");
    localStorage.setItem("user_msisdn", "");
  }
  function checkMobileNumber() {
    var mobilePattern = /^(?:\+88|88)?(01[49]\d{8})$/;
    if (mobileNumber.match(mobilePattern)) {
      return true;
    } else {
      return false;
    }
  }
  function loginOperation() {
    if (checkMobileNumber()) {
      setIsLoading(true);
      axios
        .post(
          `${baseUrl}/api/login/${
            sessionStorage.getItem("promo_code")
              ? "?promo=" + sessionStorage.getItem("promo_code")
              : ""
          }`,
          {
            msisdn: mobileNumber.toString().slice(-10),
            portal: portal,
            qcid: sessionStorage.getItem("cid"),
          }
        )
        .then((response) => {
          let data = response.data;
          let newToken = response.data.token;
          console.log(data, data?.is_verified);
          {
            localStorage.setItem("AuthToken", newToken);
            setToken(newToken);
          }
          localStorage.setItem(
            "user_msisdn",
            mobileNumber.toString().slice(-10)
          );
          activityLogSubmission(
            "login_submit",
            mobileNumber.toString().slice(-10)
          );
          analyticEvent("login", "login-success");
          // pushCleverTapEvent("Product viewed");
          if (activeBottom === "campaign") {
            if (response.data.isSubscribe) {
              navigate("../");
            } else {
              activityLogSubmission(
                "login_submit",
                mobileNumber.toString().slice(-10)
              );
              // navigate("../");
              const paramsObject = {};

              for (const [key, value] of searchParams) {
                paramsObject[key] = value;
              }

              console.log(paramsObject);
              const config = {
                headers: { Authorization: `Token ${newToken}` },
              };
              axios
                .post(
                  `${baseUrl}/subscription/create/`,
                  { portal: portal, ...paramsObject },
                  config
                )
                .then((response) => {
                  let data = response.data;
                  setShowLoginModal(false);
                  setIsLoading(false);
                  console.log(data);
                  if (data?.redirectURL) {
                    console.log(`${data?.redirectURL}`);
                    window.location.replace(`${data?.redirectURL}`);
                  }
                });
            }
          } else {
            setShowLoginModal(false);
            setIsLoading(false);
          }
        });

      // clevertap.onUserLogin.push({
      //   Site: {
      //     Name: Date.now().toString(), // String
      //     Identity: mobileNumber.toString().slice(-10), // String or number
      //     Phone: "+88" + mobileNumber.toString().slice(-10), // Phone (with the country code)
      //     DOB: new Date(), // Date of Birth. Date object
      //     // optional fields. controls whether the user will be sent email, push etc.
      //     "MSG-email": false, // Disable email notifications
      //     "MSG-push": true, // Enable push notifications
      //     "MSG-sms": true, // Enable sms notifications
      //     "MSG-whatsapp": true, // Enable WhatsApp notifications
      //   },
      // });
    } else {
      console.log("error");
      setShowErrorOutline(true);
      analyticEvent("login", "login-error");
    }
  }

  function hideModalOperation() {
    setShowLoginModal(false);
    if (activeBottom === "profile") {
      if (!playerData?.id) {
        setActiveBottom("home");
      }
    }
    if (activeBottom === "campaign") {
      navigate("../");
    }
  }
  return (
    <>
      <Modal
        show={showLoginModal}
        centered
        dialogClassName={styles.loginModalDialog}
        contentClassName={styles.loginModalContent}
        onHide={hideModalOperation}
        backdrop="static"
      >
        <img
          src={xImg}
          alt="logo"
          className={styles.xImg}
          onClick={() => {
            sessionStorage.removeItem("login_event_id");
            hideModalOperation();
          }}
        />
        <Modal.Body className={styles.loginModalBody}>
          <img src={loginIcon} alt="logo" className={styles.loginIcon} />
          <div className={styles.infoContainer}>
            <span className={styles.infoText}>
              কুইজ খেলতে রেজিস্টার/লগইন করুন
            </span>
            <div className={styles.inputContainer}>
              <span>বাংলালিংক নম্বর</span>
              <span
                className={`${styles.inputSpan} ${
                  showErrorOutline && styles.errorOutline
                }`}
              >
                <input
                  type="tel"
                  maxLength={11}
                  onKeyUp={(e) => {
                    setMobileNumber(e.target.value);
                    setIsMobileNumberOkay(checkMobileNumber());
                  }}
                  onChange={(e) => {
                    setMobileNumber(e.target.value);
                    setIsMobileNumberOkay(checkMobileNumber());
                  }}
                  onKeyDown={(e) => e.key === "Enter" && loginOperation()}
                  id="mobileNumber"
                  name="mobileNumber"
                  placeholder="০১XXXXXXXXX"
                  className={styles.inputFieldMobile}
                />{" "}
              </span>
              <button
                type="button"
                className={`btn ${styles.numberSubmit}`}
                onClick={loginOperation}
                disabled={!isMobileNumberOkay}
                style={{
                  backgroundColor: !isMobileNumberOkay ? "#757575" : "#FB005D",
                }}
              >
                {isLoading ? (
                  <Spinner animation="border" variant="light" size="sm" />
                ) : (
                  "লগইন"
                )}
              </button>
            </div>
            {parseInt(sessionStorage.getItem("cid")) === 46 && (
              <span
                style={{
                  textDecoration: "underline",
                  cursor: "pointer",
                  fontSize: "12px",
                  position: "absolute",
                  bottom: "-30px",
                  right: "6px",
                }}
                onClick={() => {
                  setShowTCModalTournament(true);
                }}
              >
                Terms & Conditions
              </span>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default LoginModal;
